import _classCallCheck from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { bytesToHex, readUInt16BE as _readUInt16BE, readUInt32BE as _readUInt32BE, readUInt8 as _readUInt } from '@stacks/common';

function createEnumChecker(enumVariable) {
  var enumValues = Object.values(enumVariable).filter(function (v) {
    return typeof v === 'number';
  });
  var enumValueSet = new Set(enumValues);
  return function (value) {
    return enumValueSet.has(value);
  };
}

var enumCheckFunctions = new Map();
export function isEnum(enumVariable, value) {
  var checker = enumCheckFunctions.get(enumVariable);

  if (checker !== undefined) {
    return checker(value);
  }

  var newChecker = createEnumChecker(enumVariable);
  enumCheckFunctions.set(enumVariable, newChecker);
  return isEnum(enumVariable, value);
}
export var BytesReader =
/*#__PURE__*/
function () {
  function BytesReader(arr) {
    _classCallCheck(this, BytesReader);

    this.consumed = 0;
    this.source = arr;
  }

  _createClass(BytesReader, [{
    key: "readBytes",
    value: function readBytes(length) {
      var view = this.source.subarray(this.consumed, this.consumed + length);
      this.consumed += length;
      return view;
    }
  }, {
    key: "readUInt32BE",
    value: function readUInt32BE() {
      return _readUInt32BE(this.readBytes(4), 0);
    }
  }, {
    key: "readUInt8",
    value: function readUInt8() {
      return _readUInt(this.readBytes(1), 0);
    }
  }, {
    key: "readUInt16BE",
    value: function readUInt16BE() {
      return _readUInt16BE(this.readBytes(2), 0);
    }
  }, {
    key: "readBigUIntLE",
    value: function readBigUIntLE(length) {
      var bytes = this.readBytes(length).slice().reverse();
      var hex = bytesToHex(bytes);
      return BigInt("0x".concat(hex));
    }
  }, {
    key: "readBigUIntBE",
    value: function readBigUIntBE(length) {
      var bytes = this.readBytes(length);
      var hex = bytesToHex(bytes);
      return BigInt("0x".concat(hex));
    }
  }, {
    key: "readUInt8Enum",
    value: function readUInt8Enum(enumVariable, invalidEnumErrorFormatter) {
      var num = this.readUInt8();

      if (isEnum(enumVariable, num)) {
        return num;
      }

      throw invalidEnumErrorFormatter(num);
    }
  }, {
    key: "readOffset",
    get: function get() {
      return this.consumed;
    },
    set: function set(val) {
      this.consumed = val;
    }
  }, {
    key: "internalBytes",
    get: function get() {
      return this.source;
    }
  }]);

  return BytesReader;
}();